module.exports = __webpack_public_path__ + "static/img/SearchDetailLogout2.8332634.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailLogout2.png
// module id = 738
// module chunks = 0